import { render } from "./TalentCard.vue?vue&type=template&id=60bcb578"
import script from "./TalentCard.vue?vue&type=script&lang=js"
export * from "./TalentCard.vue?vue&type=script&lang=js"

import "./TalentCard.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__